import { Directive, EventEmitter, HostListener, Output } from '@angular/core'

@Directive({
  selector: '[ftrFileDrop]',
  standalone: true,
})
export class FileDropDirective {
  static readonly DRAG_LEAVE_TIMEOUT = 500

  @Output() public onFilesDropped: EventEmitter<File[]>
  @Output() public onIsReadyToDrop: EventEmitter<boolean>

  dragEnterCount: number

  constructor() {
    this.onFilesDropped = new EventEmitter<File[]>()
    this.onIsReadyToDrop = new EventEmitter<boolean>()
    this.dragEnterCount = 0
  }

  // This is necessary for the 'drop' event to fire
  @HostListener('dragover', ['$event'])
  onDragOver(event: Event): void {
    preventAndStop(event)
  }

  @HostListener('dragenter', ['$event'])
  onDragEnter(event: Event): void {
    event.preventDefault()
    this.onIsReadyToDrop.emit(!!++this.dragEnterCount)
  }

  @HostListener('dragleave')
  onDragLeave(): void {
    --this.dragEnterCount
    setTimeout(() => this.onIsReadyToDrop.emit(!!this.dragEnterCount), FileDropDirective.DRAG_LEAVE_TIMEOUT)
  }

  @HostListener('dragEnd')
  onDragEnd(): void {
    this.dragEnterCount = 0
    this.onIsReadyToDrop.emit(false)
  }

  @HostListener('drop', ['$event'])
  onDrop(event: Event): void {
    preventAndStop(event)
    const transfer = getDataTransfer(event)

    if (!transfer) {
      return
    }

    this.onFilesDropped.emit(Array.from(transfer.files))

    this.dragEnterCount = 0
    this.onIsReadyToDrop.emit(false)
  }
}

function preventAndStop(event: Event): void {
  event.preventDefault()
  event.stopPropagation()
}

function getDataTransfer(event: Event | any): DataTransfer {
  return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer
}
